<template>
  <div
    class="dropdown-group origin"
    :class="{ open: isOpened, 'not-empty': notEmpty }"
  >
    <multiselect
      :id="selectedItem.code"
      :value="selectedItem"
      :options="items"
      :searchable="true"
      :placeholder="''"
      track-by="code"
      label="label"
      :close-on-select="true"
      :allow-empty="false"
      :options-limit="100"
      :show-no-results="false"
      :show-no-options="false"
      :internal-search="false"
      open-direction="bottom"
      @open="setOpened"
      @close="setClosed"
      @select="onChange"
      @search-change="$emit('search', $event)"
    >
      <template slot="caret">
        <label class="label">
          {{ label }}
        </label>
        <span class="arrow" />
      </template>
      <template
        slot="singleLabel"
        slot-scope="props"
      >
        <span class="option__title">
          <b>{{ props.option.city }}</b> ({{ props.option.code }})
        </span>
      </template>
      <template
        slot="option"
        slot-scope="props"
      >
        <div class="option__desc">
          <span class="option__title">
            {{ props.option.apt }} ({{ props.option.code }})
          </span>
          <span class="option__subtitle">
            {{ props.option.city }},
            {{ props.option.country }}
          </span>
        </div>
      </template>
    </multiselect>
  </div>
</template>

<script>
  import Multiselect from 'vue-multiselect'

  export default {
    name: 'AirportsDropdown',
    components: {
      Multiselect
    },
    props: {
      label: {
        type: String,
        default: ''
      },
      items: {
        type: Array,
        default: () => []
      },
      selectedItem: {
        type: Object,
        default: () => {}
      }
    },
    data() {
      return {
        isOpened: false
      }
    },
    computed: {
      notEmpty() {
        return !!Object.keys(this.selectedItem).length
      }
    },
    methods: {
      setOpened() {
        this.isOpened = true
      },
      setClosed() {
        this.isOpened = false
      },
      onChange(value) {
        this.$emit('change', value)
      }
    }
  }
</script>

<style
  lang="scss"
  scoped
  rel="stylesheet/scss"
>
  @import '~assets/styles/common.scss';
  @import '~assets/styles/vue-multiselect.css';

  .from-to-block {
    position: relative;
    margin: 0;
    width: 100%;

    ::v-deep .dropdown-wrap {
      margin-bottom: 16px;

      &:not(:last-of-type) {
        margin: 0 0 16px;
      }
    }

    .close {
      display: block;
      color: $blue-medium;
      font-size: em(14);
      font-weight: 500;
      line-height: 20px;
      margin-bottom: 12px;
      letter-spacing: 0;
      text-decoration: none;
      position: relative;

      &:after {
        content: $icon-close-thin;
        @include icon-font-thin();
        font-size: em(12);
        text-align: center;
        line-height: 1;
        color: $blue-medium;
        margin-left: 20px;
        position: absolute;
        right: 0;
        top: calc(50% - 4px);
      }
    }

    .add {
      display: inline-block;
      color: $blue-medium;
      font-size: em(14);
      font-weight: 500;
      line-height: 20px;
      margin-bottom: 12px;
      letter-spacing: 0;
      text-decoration: none;
    }
  }

  ::v-deep {
    .field-group {
      input {
        font-size: em(14) !important;
      }
    }

    .multiselect {
      color: $grey-default;
      font-size: em(14);

      input {
        height: 40px;
        border: none;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: rem(16, 16);
        border-radius: 0;
        color: $grey-dark;
      }
    }

    .multiselect--active {
      .arrow {
        transform: rotate(180deg);
      }
    }

    .multiselect--active,
    .multiselect__content-wrapper {
      z-index: 3;
    }

    .multiselect__content {
      max-width: 100% !important;
    }

    .multiselect__tags {
      background: #fff;
      border-radius: 5px;
      border: 1px solid $grey-border;
      display: block;
      font-size: 14px;
      height: 56px;
      padding: 16px 60px 6px 16px;
    }

    .multiselect__placeholder {
      margin-bottom: 0;
      top: calc(50% - 12px);
      position: relative;
      @include text-overflow;
      max-width: 200px;
    }

    .multiselect__input {
      font-size: em(14);
      margin-bottom: 0;
      top: -3px;
      left: -5px;
    }

    .multiselect__single {
      font-size: em(14);
      margin-bottom: 0;
      @include text-overflow;
      top: calc(50% - 8px);
      padding-left: 0;
    }

    .multiselect__element {
      max-width: 261px;
      font-size: em(14);
      @include text-overflow;

      @include bp-mf-tablet {
        max-width: 251px;
      }
    }

    .multiselect__select {
      height: 56px;

      &:before {
        display: none;
      }
    }

    .multiselect__option {
      background: white !important;
      max-width: 261px;
      font-size: em(14);
      @include text-overflow;

      @include bp-mf-tablet {
        max-width: 251px;
      }

      &:after {
        display: none;
      }

      &:hover,
      &:focus {
        background: $gray-marble !important;
      }
    }

    .multiselect__tag-icon:focus,
    .multiselect__tag-icon:hover {
      background: $gray-marble !important;
    }

    .multiselect__option--selected {
      background-color: $gray-marble;
      color: $blue-medium;
      font-weight: 500;

      .multiselect__option--highlight {
        background-color: $gray-marble;
        color: $blue-medium;

        &:after {
          background-color: $gray-marble;
          color: $blue-medium;
          content: attr(data-deselect);
        }
      }
    }
  }

  .option__title {
    font-size: rem(16, 16);
    color: $blue-dark;
    display: block;
  }

  .option__subtitle {
    font-size: rem(12, 16);
    color: $input-placeholder;
    margin-top: 5px;
    display: block;
  }

  .open {
    .arrow {
      display: none;
    }
  }

  .label {
    position: absolute;
    top: 7px;
    left: 16px;
    color: $blue-light;
    font-size: rem(11, 16);
    z-index: 1;
  }

  .arrow {
    position: absolute;
    right: 19px;
    line-height: 16px;
    top: calc(50% - 20px);
    display: block;
    width: 40px;
    height: 40px;

    &::after {
      content: $filled-icon-caret;
      @include filled-icon-font();
      font-size: 16px;
      color: $blue-dark;
      position: absolute;
      left: calc(50% - 8px);
      top: calc(50% - 8px);
    }
  }

  .not-empty ::v-deep .multiselect .label {
    position: absolute;
    transition: all 0.2s ease;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    pointer-events: none;
    color: rgba(21, 38, 73, 0.6);
    top: 7px;
    letter-spacing: 0;
    line-height: 14px;
  }
</style>
